var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`info-box ${_vm.type}`},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.content)?_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]):_vm._e(),_c('div',{staticClass:"custom-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }